module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-192.99c86748.svg";